import { Drawer } from 'vaul';
import { styled } from 'styled-components';
import { cssVar } from '../theme/variables.js';
import { mediaMobile } from '../constants/styled-utils.js';

const DrawerRoot = Drawer.Root;
const DrawerTrigger = Drawer.Trigger;
const DrawerPortal = Drawer.Portal;
const DrawerClose = Drawer.Close;
const DrawerOverlay = styled(Drawer.Overlay).withConfig({
  displayName: "VaulDrawer__DrawerOverlay",
  componentId: "sc-15bb9612-0"
})([
  `position:fixed;inset:0;z-index:125;background-color:`,
  `;will-change:opacity;`
], cssVar["color-bg-overlay"]);
const DrawerContent = styled(Drawer.Content).withConfig({
  displayName: "VaulDrawer__DrawerContent",
  componentId: "sc-15bb9612-1"
})([
  `position:fixed;left:0;right:0;bottom:0;z-index:125;margin-top:6rem;display:flex;flex-direction:column;height:auto;border-top-left-radius:2rem;border-top-right-radius:2rem;border:1px solid `,
  `;background:`,
  `;padding-bottom:env(safe-area-inset-bottom);&:focus-visible{outline:none;}`
], cssVar["color-border-primary"], cssVar["color-bg-primary"]);
const DrawerHandle = styled.div.withConfig({
  displayName: "VaulDrawer__DrawerHandle",
  componentId: "sc-15bb9612-2"
})([
  `margin:0 auto;margin-top:1rem;height:0.375rem;width:3rem;border-radius:0.625rem;background:`,
  `;`
], cssVar["color-bg-quarternary"]);
const DrawerHeader = styled.div.withConfig({
  displayName: "VaulDrawer__DrawerHeader",
  componentId: "sc-15bb9612-3"
})([
  `display:grid;gap:1rem;padding:1rem;text-align:center;`,
  `{text-align:left;}`
], mediaMobile);
const DrawerTitle = styled(Drawer.Title).withConfig({
  displayName: "VaulDrawer__DrawerTitle",
  componentId: "sc-15bb9612-4"
})([
  `color:`,
  `;font-size:20px;font-weight:600;line-height:24px;font-style:normal;display:inline-flex;align-items:center;`
], cssVar["color-text-primary"]);
const VaulDrawer = {
  Root: DrawerRoot,
  Trigger: DrawerTrigger,
  Portal: DrawerPortal,
  Close: DrawerClose,
  Overlay: DrawerOverlay,
  Content: DrawerContent,
  Handle: DrawerHandle,
  Header: DrawerHeader,
  Title: DrawerTitle
};

export { VaulDrawer };
//# sourceMappingURL=VaulDrawer.js.map
